// Passport copy logic

import {
  inferGenderFromOcrText,
  normalizeGender,
} from "../shared/normalizers";
import {
  normalizeFieldsFromSchema,
  resolveExtractedRawValue,
} from "../shared/fieldNormalization";
import { isSupportedUploadFile } from "../shared/uploadMime";

const required = (value) =>
  value && String(value).trim() ? null : "This field is required.";

const schema = {
  type: "passport_copy",
  title: "Passport Copy",
  groups: [
    { id: "identity", label: "Identity" },
    { id: "numbers", label: "Numbers" },
    { id: "dates", label: "Dates" },
  ],
  fields: [
    { key: "surname", label: "Surname", group: "identity", inputType: "text" },
    {
      key: "given_name",
      label: "Given Name",
      group: "identity",
      inputType: "text",
    },
    {
      key: "nationality",
      label: "Nationality",
      group: "identity",
      inputType: "text",
    },
    {
      key: "sex",
      label: "Sex",
      group: "identity",
      inputType: "select",
      options: ["Male", "Female", "Other"],
    },
    {
      key: "place_of_birth",
      label: "Place of Birth",
      group: "identity",
      inputType: "text",
    },
    {
      key: "father_name",
      label: "Father Name",
      group: "identity",
      inputType: "text",
    },
    {
      key: "passport_number",
      label: "Passport Number",
      group: "numbers",
      inputType: "text",
      required: true,
      validate: required,
    },
    {
      key: "citizenship_number",
      label: "Citizenship Number",
      group: "numbers",
      inputType: "text",
    },
    {
      key: "date_of_birth",
      label: "Date of Birth",
      group: "dates",
      inputType: "date",
    },
    {
      key: "date_of_issue",
      label: "Issue Date",
      group: "dates",
      inputType: "date",
    },
    {
      key: "date_of_expiry",
      label: "Expiry Date",
      group: "dates",
      inputType: "date",
    },
  ],
};

const enrichExtractedJson = (extracted, rawText = "") => {
  const data = { ...(extracted || {}) };
  const text = String(rawText || "").trim();
  if (!text) return data;

  const current = resolveExtractedRawValue(data, "sex");
  const normalized = normalizeGender(current);
  if (!normalized) {
    const inferred = inferGenderFromOcrText(text);
    if (inferred) data.sex = inferred;
  }

  return data;
};

const getLlmExtractionFields = () => schema.fields.map((field) => field.key);

const validateFieldValue = (key, value) => {
  const def = schema.fields.find((field) => field.key === key);
  if (!def || typeof def.validate !== "function") return null;
  return def.validate(value);
};

const normalizeExtractedJson = (extracted, rawText = "") => {
  const enriched = enrichExtractedJson(extracted, rawText);
  return normalizeFieldsFromSchema(schema, enriched, rawText);
};

const buildTableFromExtracted = () => null;

const appendTableToExtractedJson = (obj) => obj;

export const passportType = {
  key: "passport_copy",
  schema,
  getLlmExtractionFields,
  enrichExtractedJson,
  normalizeExtractedJson,
  validateFieldValue,
  isSupportedFile: isSupportedUploadFile,
  buildTableFromExtracted,
  appendTableToExtractedJson,
};
